import { render, staticRenderFns } from "./FacilityIconList.vue?vue&type=template&id=887b8e3a"
import script from "./FacilityIconList.vue?vue&type=script&lang=js"
export * from "./FacilityIconList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports